import React from 'react';

const Contact = () => {
  return (
    <div className="container" style={{ textAlign: 'left', lineHeight: '1.8' }}>
      <h2>문의 및 제안</h2>
      <p>
        '두바이 쫀득쿠키 심리테스트'에 대한 사용자 여러분의 모든 의견을 소중하게 생각하며, 언제나 열린 마음으로 여러분의 목소리를 기다리고 있습니다.
      </p>
      <p>
        서비스를 이용하시면서 느끼셨던 불편한 점이나 개선이 필요한 부분, '이런 기능이 추가되면 좋겠다'와 같은 아이디어, 심리테스트나 블로그 콘텐츠에 대한 제안 등 어떤 내용이든 좋습니다. 파트너십 및 기타 비즈니스 협력에 대한 문의도 환영합니다.
      </p>
      <p>
        아래 이메일로 연락 주시면, 보내주신 내용을 꼼꼼히 검토하여 최대한 신속하게 답변을 드릴 수 있도록 노력하겠습니다. 일반적으로 영업일 기준 2~3일 이내에 회신을 드리고자 하나, 문의량이 많거나 검토에 시간이 필요한 경우 다소 지연될 수 있는 점 양해 부탁드립니다.
      </p>
      <p>
        여러분의 관심과 참여가 '두바이 쫀득쿠키 심리테스트'를 더욱 즐겁고 유익한 공간으로 만들어가는 가장 큰 원동력입니다.
      </p>
      <p>
        감사합니다.
      </p>
      <p>
        <strong>이메일:</strong> djkcookie3800@gmail.com
      </p>
    </div>
  );
};

export default Contact;
